import {NinchatArrowDownIcon} from '../Icon'
import React from 'react'
import {ScrollToBottomViewProps} from './types'
import styles from './styles/ScrollToBottomView.module.scss'
import {useTranslation} from 'react-i18next'

const ScrollToBottomView = ({
    onClick, display, type, isHighlighting,
}: ScrollToBottomViewProps): React.ReactElement => {
    const {t} = useTranslation()
    return (
        <div className={`${styles.ScrollToBottomView} ${styles[display]} ${isHighlighting ? styles.highlight : ''}`}>
            <button aria-label={t('Scroll to bottom')} className='rowParent' onClick={onClick} title={t('Scroll to bottom')} type='button'>
                {type === 'newMessage' && <span>{t('New messages')}</span>}
                <NinchatArrowDownIcon />
            </button>
        </div>
    )
}


export default ScrollToBottomView
